// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"03e38b6b16d8e7751d3c","404":"ec533a4756fb5c7b8cdf","406":"2dc3af74f57313019007"}[chunkId] + ".css";
};